import * as Yup from 'yup';

const transformNumber = function (o, v) {
    var ret = v;

    if (v && v.replace) 
        ret = Number(v.replace(/,/, '.'));

    return ret;
}

const useForm = (possuiImpressora) => {
    const validationSchema = Yup.object().shape({
        numeroEtiqueta: !possuiImpressora ? Yup.string().required('Campo obrigatório') : '',
        tipoLote: Yup.string().required('Campo obrigatório'),
        tipoConservacaoLote: Yup.string().required('Campo obrigatório'),
        temperatura: Yup.number().transform((o, v) => transformNumber(o, v)),
        empresa: Yup.string().required('Campo obrigatório')
    });

    const baseValues = { 
        numeroEtiqueta: '',
        tipoLote: '',
        tipoConservacaoLote: '',
        temperatura: '',
    };

    const initialValues = baseValues;

    const initialErrors = baseValues;

    return {
        validationSchema,
        initialValues,
        initialErrors,
    };
};

export default useForm;